import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import ProfileListItem from "@/components/ProfileListItem.vue";
import { SearchItem, StateRepresentative } from "@/types";
import { computed, ref, watch } from "vue";
import { VignetteGroupMember } from "@/types/nj/Groups";

interface Props {
  members: SearchItem[] | StateRepresentative[] | VignetteGroupMember[];
  isSelectEnabled: boolean;
  isBriefcaseView: boolean;
  showFilters?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileList',
  props: {
    members: null,
    isSelectEnabled: { type: Boolean },
    isBriefcaseView: { type: Boolean },
    showFilters: { type: Boolean }
  },
  emits: ["clear-filter"],
  setup(__props: any, { emit }) {

const props = __props as {
  members: SearchItem[] | StateRepresentative[] | VignetteGroupMember[];
  isSelectEnabled: boolean;
  isBriefcaseView: boolean;
  showFilters?: boolean;
};




const showFilters = computed(() => props.showFilters ?? false);
const members = computed(() => props.members);

const search = ref("");

const partyFilter = ref("Any");
watch(partyFilter, (v) => {
  if (v === null) partyFilter.value = "Any";
});

const hasPoliticalParty = (
  m: SearchItem[] | StateRepresentative[] | VignetteGroupMember[]
): m is StateRepresentative[] => {
  if (m.length > 0) {
    return "politicalParty" in m[0];
  } else {
    return false;
  }
};

const partiesInMembers = computed(() => {
  const parties = new Set<string>();
  if (!hasPoliticalParty(members.value)) return [];
  members.value.forEach((member) => {
    if (member.politicalParty) parties.add(member.politicalParty);
  });
  return Array.from(parties);
});

const filteredMembers = computed(() => {
  let result = [];
  if (partyFilter.value === "Any") result = members.value;
  else {
    if (!hasPoliticalParty(members.value)) return [];
    for (const member of members.value) {
      if (member.politicalParty === partyFilter.value) {
        result.push(member);
      }
    }
  }
  if (!search.value) return result;
  return result.filter((m) => {
    const name = m.preferredNameDisplay.toLowerCase();
    const position = m.positionSummary.toLowerCase();
    const s = search.value.toLowerCase();
    return name.includes(s) || position.includes(s);
  });
});

const clearFilters = () => {
  search.value = "";
  partyFilter.value = "Any";
  emit("clear-filter");
};

return { __sfc: true,emit, props, showFilters, members, search, partyFilter, hasPoliticalParty, partiesInMembers, filteredMembers, clearFilters, NjBtn, ProfileListItem }
}

})